var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawalHoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#E42125"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 7.49166V16.475C15.8333 16.6452 15.7657 16.8084 15.6454 16.9287C15.525 17.0491 15.3618 17.1167 15.1917 17.1167H6.20832C6.03814 17.1167 5.87493 17.0491 5.75459 16.9287C5.63425 16.8084 5.56665 16.6452 5.56665 16.475V4.92499C5.56665 4.75481 5.63425 4.5916 5.75459 4.47126C5.87493 4.35093 6.03814 4.28333 6.20832 4.28333H12.625M15.8333 7.49166H12.625V4.28333M15.8333 7.49166L12.625 4.28333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73747 11.0208L8.1333 12.625L9.73747 14.2291",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1333 12.625H13.2666V10.0583",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalHoverIcon);
export default __webpack_public_path__ + "static/media/withdrawalHoverIcon.07cc90a6965fc637b2caa12480fb6bf6.svg";
export { ForwardRef as ReactComponent };